import PerfectScrollbar from 'perfect-scrollbar';


(function() {
	const _init = () => {
		document.querySelectorAll('.scrollable').forEach(s => _addScroll(s));
		
		document.querySelectorAll('.scrollable-x').forEach(s => {
			_addScroll(s, {
				suppressScrollY: true,
				useBothWheelAxes: true,
			});
		});
		
		document.querySelectorAll('.scrollable-y').forEach(s => {
			_addScroll(s, {
				suppressScrollX: true,
			});
		});
	};
	
	const _addScroll = (s, options = {}) => {
		if( ! s.classList.contains('ps') ) {
			new PerfectScrollbar(s, options);
		}
	};
	
	_init();
	document.addEventListener('pageLoad', () => _init() );
})();